<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="3">
        <v-select :items="years" label="Select Year" v-model="theYear"></v-select>
        <v-select prepend-icon="mdi-account" clearable v-model="technician" label="Select Technician for Report" item-text="name" item-value="name" :items="appTechnicians" />
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn :loading="loading" :disabled="loading" @click="getData" color="primary" large class="ml-3">View Report</v-btn>
        <v-btn v-if="res.records.length > 0" :loading="loading" :disabled="loading" @click="saveData" color="secondary" large class="ml-3">Save Report</v-btn>
      </v-col>
      <v-col cols="12">
        <div v-for="(r, i) in res.records" :key="i">
          <v-card class="mt-2">
            <v-card-title>{{r._id}}</v-card-title>
            <v-card-text>
              <h4 class="title" :class="r.value < 1650 ? 'error--text' : ''">Total: {{accounting.formatMoney(r.value, '£', 2) }}</h4>
              <v-checkbox v-model="r.isOk" label="Is this figure acceptable?"></v-checkbox>
              <v-textarea v-if="!r.isOk" v-model="r.text" placeholder="Enter reason text"></v-textarea>
            </v-card-text>
          </v-card>
        </div>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import {ReportsHttp} from "@/http/ReportsHttp";
import accounting from 'accounting';
import {PeriodsHttp} from "@/http/PeriodsHttp";

export default {
  name: "AnnualTechnicianReport",
  computed: {
    ...mapState("technicians", ["appTechnicians"]),
    computedStartDate () {
      return this.start ? this.$moment(this.start).format('DD/MM/YYYY') : ''
    },
    computedEndDate () {
      return this.end ? this.$moment(this.end).format('DD/MM/YYYY') : ''
    },
  },
  data() {
    return {
      start: null,
      end: null,
      startModal: false,
      endModal: false,
      technician: '',
      annual: true,
      loading: false,
      res: {records: []},
      accounting: accounting,
      periods: [],
      theYear: '',
      years: []
    }
  },
  async mounted() {
    this.periods = await PeriodsHttp.getPeriods().then(result => result.data);
    this.periods.forEach(p => {
      const start = new Date(p.endDate);
      const year = start.getFullYear();
      const index = this.years.findIndex(x => x === year);
      if (index === -1) {
        this.years.push(year);
      }
    });
  },
  methods: {
    ...mapMutations("app", ["setToast"]),
    async getData() {
      try {
        this.res = {records: []};
        this.loading = true;
        const periodsSelected = this.periods.filter(x => x.name.indexOf(this.theYear) > -1);

        let start = periodsSelected[0].startDate;
        let end = periodsSelected[periodsSelected.length -1].endDate;

        this.res = await ReportsHttp.getTechAnnual(start, end, this.technician).then(r => r.data);
      } catch (e) {
        this.setToast({color: 'error', text: e.response.data, show: true})
      } finally {
        this.loading = false;
      }
    },
    async saveData() {
      this.loading = true;
      try {
        await ReportsHttp.updateAnnualReport(this.res);
        this.setToast({color: 'success', text: 'Report saved successfully', show: true})
      } catch (e) {
        this.setToast({color: 'error', text: e.response.data, show: true})
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>

</style>
